import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.108 21.207c2.587-.28 5.197-.28 7.785 0a1 1 0 1 0 .215-1.988 38.2 38.2 0 0 0-8.215 0 1 1 0 1 0 .215 1.988"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 4.06a2 2 0 0 0-1.75 1.03l-3.67 6.616-.005.005h-.01L4.245 8.898l-.004-.001a2 2 0 0 0-2.75 2.296v.004l3.174 13.53.002.009a2.013 2.013 0 0 0 2.484 1.466l.004-.001a33.1 33.1 0 0 1 17.68 0h.003a2.01 2.01 0 0 0 2.485-1.465l3.188-13.54v-.002a2 2 0 0 0-2.75-2.297l-.004.001-6.322 2.811h-.008l-.007-.004-3.669-6.615-2.766-.754 2.766.753A2 2 0 0 0 16 4.06m-4.799 9.55c.473-.156.871-.482 1.118-.914L16 6.06l3.675 6.626.006.01a2.01 2.01 0 0 0 2.56.845l.003-.002 6.322-2.81-.002.005-3.186 13.53v.002l-.002.003-.005.004h-.008l-.263.965.267-.964h-.004a35.1 35.1 0 0 0-18.746-.001l-.002-.001-.001-.001-.005-.006-3.173-13.53-.001-.007 6.321 2.811.004.002c.455.2.969.225 1.441.069"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconCrown = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconCrown);
export default Memo;
